import styled from 'styled-components';

export const ConfirmTermsAndConditionsPricelistTextStyle = styled.div`
  margin-bottom: 2em;
  text-align: center;
`;
